import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-4" }
const _hoisted_2 = {
  for: "email",
  class: "form-label"
}
const _hoisted_3 = { class: "text-lg" }
const _hoisted_4 = { class: "mb-4" }
const _hoisted_5 = {
  for: "password",
  class: "form-label"
}
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = { class: "form-error-text" }
const _hoisted_8 = { class: "mb-4" }
const _hoisted_9 = {
  for: "password_confirmation",
  class: "form-label"
}
const _hoisted_10 = ["placeholder"]
const _hoisted_11 = { class: "form-error-text" }
const _hoisted_12 = { class: "flex items-center justify-between pt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_form_submit = _resolveComponent("base-form-submit")!
  const _component_base_shadow_card = _resolveComponent("base-shadow-card")!
  const _component_layouts_guest = _resolveComponent("layouts-guest")!

  return (_openBlock(), _createBlock(_component_layouts_guest, null, {
    default: _withCtx(() => [
      _createVNode(_component_base_shadow_card, { title: "ログインパスワードの設定" }, {
        default: _withCtx(() => [
          _createElementVNode("form", {
            onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.t('word.email')), 1),
              _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.email), 1)
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.t('word.password_new')), 1),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.password) = $event)),
                id: "password",
                name: "password",
                type: "password",
                placeholder: _ctx.t('word.password_new'),
                class: _normalizeClass(`form-input ${_ctx.errors['password'] ? '!border-red-500' : ''}`)
              }, null, 10, _hoisted_6), [
                [_vModelText, _ctx.password]
              ]),
              _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.errors['password']), 1)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.t('word.password_confirmation')), 1),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password_confirmation) = $event)),
                id: "password_confirmation",
                name: "password_confirmation",
                type: "password",
                placeholder: _ctx.t('word.password_confirmation'),
                class: _normalizeClass(`form-input ${_ctx.errors['password_confirmation'] ? '!border-red-500' : ''}`)
              }, null, 10, _hoisted_10), [
                [_vModelText, _ctx.password_confirmation]
              ]),
              _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.errors['password_confirmation']), 1)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_base_form_submit, {
                disabled: _ctx.btnDisabled,
                text: "設定する"
              }, null, 8, ["disabled"])
            ])
          ], 32)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}